import React from 'react';
import PropTypes from 'prop-types';
import { Creator } from 'apps/find-designers/propTypes';
import { DisplayName } from '@99designs/common/components/DisplayName';
import DesignerBrandingExtras from 'apps/find-designers/components/Listing/DesignerBrandingExtras';
import { getDesignerLevel, isContact } from 'apps/find-designers/utils/designers';

const DesignerBranding = ({ designer, profileUrl }) => (
    <div className="designer-branding">
        <div className="designer-branding__details">
            <div className="designer-branding__details__name">
                <DisplayName
                    user={{ name: designer.displayName, profileUrl }}
                    variations={['non-attribution']}
                />
            </div>
            <span className="designer-branding__details__extras">
                <DesignerBrandingExtras
                    level={getDesignerLevel(designer.designerLevel)}
                    isContact={isContact(designer.flags)}
                />
            </span>
        </div>
    </div>
);

DesignerBranding.propTypes = {
    designer: Creator.isRequired,
    profileUrl: PropTypes.string.isRequired,
};

export default DesignerBranding;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignerBranding.jsx